import React from 'react'

import { QsehraSignupComponentKey, RoutesMapping, SectionType } from 'adminSignUp'

import { TaxClassificationValues } from 'core/application/adminSignUp/common/models'
//
import taxClassificationApi from 'core/application/adminSignUp/qsehra/taxClassification'
import { ProductIds } from 'core/application/commons/config'
import { CompanyType } from 'core/domain/benefit/companyType'

import { BaseNavigationProps } from 'common/wizard/BaseNavigationProps'

import TaxClassification from '../common/TaxClassification'

const QsehraTaxClassification: React.FC<BaseNavigationProps<TaxClassificationValues>> = (props) => {
  const QsehraSteps = RoutesMapping.get(ProductIds.QsehraId).filter(
    (i) => i.sectionType === SectionType.COMPANY_DETAILS,
  )

  return (
    <TaxClassification
      descriptionMap={descriptionMap}
      companyTypeId={props.state.companyTypeId}
      taxClassificationApi={taxClassificationApi}
      numberOfQuestions={QsehraSteps.length}
      currentQuestion={QsehraSteps.findIndex((i) => i.key === QsehraSignupComponentKey.TAX_CLASSIFICATION) + 1}
      {...props}
    />
  )
}

export default QsehraTaxClassification

const descriptionMap = (translate: any): Map<number, string> =>
  new Map<number, string>([
    [
      CompanyType.CCorpNonProfitOrMunicipality,
      translate('admin-signup.company-details.tax-classification.qsehra.c-corp-description'),
    ],
    [CompanyType.Scorp, translate('admin-signup.company-details.tax-classification.qsehra.s-corp-description')],
    [
      CompanyType.Partnership,
      translate('admin-signup.company-details.tax-classification.qsehra.partnership-description'),
    ],
    [
      CompanyType.SoleProprietors,
      translate('admin-signup.company-details.tax-classification.qsehra.sole-proprietors-description'),
    ],
    [
      CompanyType.LLCFilingAsSCorp,
      translate('admin-signup.company-details.tax-classification.qsehra.llc-as-s-corp-description'),
    ],
    [
      CompanyType.LLCFilingAsPartnership,
      translate('admin-signup.company-details.tax-classification.qsehra.llc-as-partnership-description'),
    ],
  ])
